<template>
    <!-- <z-basePage :title="'奖金周期'"> -->
        <z-backForm :name="'back-bonus-cycle'" :align="true" @save="saveSet" @cancel="backset" v-loading.fullscreen.lock="full_screenFlag">
            <!-- 基本设置 -->
            <div class="small-title">奖金周期</div>
            <div class="back-item">
                <div class="back-title">起始月份</div>
                <div class="back-wrap">
                    <el-select class="top-choose" rule="noVal" v-tar="sub.startMonth" v-model="sub.startMonth" placeholder="请选择">
						<el-option v-for="month in 12" :key="month" :value="month" :label="`${month}月`">
						</el-option>
					</el-select>
                    <div class="tip">下一周期起始月份</div>
                </div>
            </div>
            <div class="back-item">
                <div class="back-title">周期间隔</div>
                <div class="back-wrap">
                    <el-select class="top-choose" rule="noVal" v-tar="sub.type" v-model="sub.type" placeholder="请选择">
						<el-option v-for="item in cycle_interval" :key="item.val" :value="item.val" :label="item.text">
						</el-option>
					</el-select>
                    <div class="tip">{{ sub.startMonth | cycleTip(sub.type) }}</div>
                </div>
            </div>
            <!-- 分配阶段 -->
            <div class="small-title">奖金分配</div>
            <div class="back-item">
                <div class="back-title">分配时长</div>
                <div class="back-wrap">
                    <el-input class="top-choose" rule="number cycle_day" v-arg="5" v-tar="sub.distribute_days" v-model="sub.distribute_days" >
                        <template slot="append">工作日</template>
                    </el-input>
                    <div class="tip">奖金分配的持续时间</div>
                </div>
            </div>
            <!-- <div class="back-item">
                <div class="back-title">最低分配比例</div>
                <div class="back-wrap">
                    <el-select class="top-choose" rule="noVal" v-tar="sub.min_ratio" v-model="sub.min_ratio" placeholder="请选择">
						<el-option v-for="item in percentArr" :key="item.val" :value="item.val" :label="item.text">
						</el-option>
					</el-select>
                    <div class="tip">BU合伙人分配奖金总额不低于最低分配比例</div>
                </div>
            </div> -->
            <!-- 结算阶段 -->
            <div class="small-title">奖金结算</div>
            <div class="back-item">
                <div class="back-title">结算时长</div>
                <div class="back-wrap">
                    <el-input class="top-choose" rule="number cycle_day" v-arg="5" v-tar="sub.settle_days" v-model="sub.settle_days" >
                        <template slot="append">工作日</template>
                    </el-input>
                    <div class="tip">系统完成奖金结算的持续时间，默认在奖金分配结束后开启</div>
                </div>
            </div>
        </z-backForm>
    <!-- </z-basePage> -->
</template>

<script>
    import { mapState } from 'vuex'
    export default {
        data(){
            return{
                full_screenFlag:false,
                sub:{
                    startMonth:"",  //下周期起始月
                    type:"",  //周期间隔
                    distribute_days:"",  //分配时长
                    min_ratio:"",  //职员最低分配比例  
                    settle_days:"",  //结算时长
                },
            }
        },

        computed:{
            ...mapState(['cycle_interval']),       
            // percentArr(){ //比例  option
            //     let arr = [];
            //     for(let i=0;i<10;i++){
            //         let num = (i+1)*10;
            //         arr.push({
            //             val:num,
            //             text:num+"%",
            //         });
            //     }
            //     return arr;
            // }
        },

        filters:{
            // cycleTip(start,type){
            //     if(!start || !type){
            //         return "";
            //     }
            //     let interval = 1;  //间隔月份
            //     switch (type){
            //         case 10:
            //             interval = 1;
            //             break;
            //         case 20:
            //             interval = 3;
            //             break;
            //         case 30:
            //             interval = 6;
            //             break;
            //         case 40:
            //             interval = 12;
            //             break;
            //     }
            //     let arr = [];
            //     let month = start;
            //     do{
            //         month+=interval;
            //         if(month>12){
            //             month = month - 12;
            //         }
            //         arr.push(month);
            //     }while(month != start)
            //     let str = arr.sort((a,b)=>{
            //         return a-b;
            //     }).map(val=>val+"月").join('、');
            //     return `周期将于${str}开启`

            // },
        },

        created(){
            this.getData();
        },

        methods:{
            getData(){
                let url = `api/clerk/cfg_bonus`;
                this.$http.get(url).then(res=>{
                    if(res.status == 200){
                        let data = res.res_data;
                        let sub = this.sub;

                        sub.startMonth = data.bonusStartMonth;
                        sub.type = data.bonusDistributeType;
                        sub.distribute_days = data.bonusDistributeDays;
                        sub.min_ratio = data.bonusMemberMinRatio;
                        sub.settle_days = data.bonusMemberClearingDays;
                        this.$form.init("back-bonus-cycle");
                    }
                });
            },
            saveSet(){
                this.full_screenFlag = true;
                let sub = this.sub;
                let url = `api/admin/cfg_bonus`;
                this.$http.post(url,{
                    start_month:sub.startMonth,
                    distribute_type:sub.type,
                    distribute_days:sub.distribute_days,
                    // member_min_ratio:sub.min_ratio,
                    member_min_ratio:0,
                    member_clearing_days:sub.settle_days,
                }).then(res=>{
                    if(res.status == 200){
                        this.getData();
                        this.successTip("保存成功");
                    }
                    this.full_screenFlag = false;
                }).catch(err=>{
                    this.full_screenFlag = false;
                    this.errorTip("出错了");
                });
            },
            backset(dataArr){
                let sub = this.sub;
                [
                    sub.startMonth,
                    sub.type,
                    sub.distribute_days,
                    sub.min_ratio,
                    sub.settle_days,
                ] = dataArr;
                this.$form.clear('back-bonus-cycle');
            },
        }
    }
</script>

<style lang="less">

</style>


// WEBPACK FOOTER //
// bonus-cycle.vue?9fba09a2